import { render, staticRenderFns } from "./DocumentsPopups.vue?vue&type=template&id=6cb64250"
import script from "./DocumentsPopups.vue?vue&type=script&lang=ts"
export * from "./DocumentsPopups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports